import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {updateOrgBilling} from "../../generic/crud";
import {showToast, TOAST_FAILURE, TOAST_SUCCESS} from "../../../utils/toast/Toast";

export function BillingConfigDialog(props) {
    const {show, handleClose, org, onSave} = props;
    const [isLoading, setIsLoading] = useState(false);

    const defaultValues = {
        monthlyBillingAmount: 0,
        maxAllowedBranches: 1,
        billingStatus: "DEMO",
    };

    const [initialValues, setInitialValues] = useState(defaultValues);

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit(values) {
            setIsLoading(true);
            updateOrgBilling(org.id, values).then(() => {
                setIsLoading(false);
                handleClose();
                showToast("Billing configuration updated!", TOAST_SUCCESS);
                if (onSave) onSave();
            }).catch((err) => {
                setIsLoading(false);
                showToast(err.response?.data || "Error updating billing.", TOAST_FAILURE);
            });
        }
    });

    useEffect(() => {
        if (org) {
            setInitialValues({
                monthlyBillingAmount: org.monthlyBillingAmount || 0,
                maxAllowedBranches: org.maxAllowedBranches || 1,
                billingStatus: org.billingStatus || "DEMO",
            });
        } else {
            setInitialValues(defaultValues);
        }
    }, [show, org]);

    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Configure Billing - {org?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">
                            <Form.Group className="col-lg-6 mb-5">
                                <Form.Label className="required">Monthly Billing Amount per Branch (₹)</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    id="monthlyBillingAmount"
                                    placeholder="Enter amount per branch"
                                    value={formik.values.monthlyBillingAmount}
                                    onChange={formik.handleChange}
                                />
                                <Form.Text className="text-muted">Price per branch per month. Total = this amount x number of branches.</Form.Text>
                            </Form.Group>

                            <Form.Group className="col-lg-6 mb-5">
                                <Form.Label className="required">Max Allowed Branches</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    step="1"
                                    id="maxAllowedBranches"
                                    placeholder="Enter max branches"
                                    value={formik.values.maxAllowedBranches}
                                    onChange={formik.handleChange}
                                />
                                <Form.Text className="text-muted">Maximum number of branches this organization can create</Form.Text>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6 mb-5">
                                <Form.Label className="required">Billing Status</Form.Label>
                                <Form.Select
                                    id="billingStatus"
                                    value={formik.values.billingStatus}
                                    onChange={formik.handleChange}>
                                    <option value="DEMO">Demo</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="WARNING">Warning</option>
                                    <option value="SUSPENDED">Suspended</option>
                                    <option value="CANCELLED">Cancelled</option>
                                </Form.Select>
                                <Form.Text className="text-muted">Current billing status of the organization</Form.Text>
                            </Form.Group>
                        </div>
                    </Form>
                )}
                {isLoading && <span>Please Wait...</span>}
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-light btn-elevate"
                    onClick={handleClose}>
                    Cancel
                </button>
                <button
                    type="submit"
                    onClick={formik.handleSubmit}
                    className="btn btn-primary btn-elevate">
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    );
}
